'use client'

import type { ComponentProps, ReactNode } from 'react'
import { useTrackingUrl } from '../../hooks/use-tracking-url'
import { CTA, SCHEDULE_TRACKING_OPTIONS } from '../../utils/ctas'
import { ButtonCTA } from '../ButtonCTA'

type Props = {
  id?: string
  className?: string
  segmentElement: string
  children?: ReactNode
  size?: ComponentProps<typeof ButtonCTA>['size']
  variant?: ComponentProps<typeof ButtonCTA>['variant']
  /** Defaults to /schedule_form; pass CTA.SCHEDULE_A_CALL for direct Calendly booking. */
  baseUrl?: string
}

export const ScheduleCallCTA = ({
  segmentElement,
  id,
  className,
  size,
  variant,
  children,
  baseUrl = CTA.SCHEDULE_FORM_PAGE,
}: Props) => {
  const url = useTrackingUrl(baseUrl, SCHEDULE_TRACKING_OPTIONS)
  return (
    <ButtonCTA
      id={id}
      href={url}
      className={className}
      aria-label="Schedule a call with a Financial Advisor"
      segmentElement={segmentElement}
      size={size}
      variant={variant}
    >
      {children ?? 'Schedule a call'}
    </ButtonCTA>
  )
}
